/* eslint-disable max-len */
const zhTw = {
  CancellationRequest: '要求取消',
  Heading: '請提供以下資訊。請填寫所有欄位。',
  Note: '需要取消您的預訂嗎？　有問題嗎？我們來幫忙！填寫以下欄位，指定您要取消的預訂。',
  PartnerNote:
    '謝謝！目前行程出發時間較早的取消要求會優先處理。如果我們沒有在您的出發日期前確認取消，請不用擔心，我們都有在處理。您不需要做任何事情。',
  SubmitNote:
    '由於許多旅客都需要變更或取消行程，退款流程可能會有所延誤。造成您的不便，我們深感抱歉，也感謝您的耐心等候。',
  Disclaimer:
    '重要說明：此表單僅適用於旅遊日期在 2021 年 12 月 31 日之前的預訂。',
  Itin: '行程編號 (行程或確認電子郵件上的 11 - 15 碼)',
  EmailAddress: '此預訂使用的電子郵件地址',
  PhoneNumber: '此預訂使用的電話號碼',
  Reason: '原因',
  Submit: '繼續',
  Success: '我們已收到您的申請',
  Failed: '很抱歉',
  InProgress: '正在處理中',
  TryAgain: '返回',
  PhoneErrorMessage: '請輸入有效的電話號碼',
  EmailErrorMessage: '請輸入有效的電子郵件地址',
  ItinErrorMessage: '請輸入有效的行程編號',
  ResponseEligibleHeader: '我們找到了您的行程',
  ResponseEligibleSubmit: '取消預訂',
  ResponseEligibleNeverMind: '不要取消',
  ResponseOnlyLodgingWithRefund:
    '您有 {x} 筆住宿預訂在取消後能獲得退款。如果您選擇取消，我們會透過原付款方式退款給您。',
  ResponseOnlyLodgingWithCoupon:
    '您有 {x} 筆住宿預訂在取消後能以優惠券的形式獲得抵用券。若您選擇取消預訂，我們會核發給您等同於原先預訂金額的優惠券。',
  ResponseOnlyLodgingInEligible:
    '您有 {x} 筆住宿預訂不得免費取消。如果您選擇取消預訂，我們會依照住宿方的標準取消規定處理。',
  ResponseLodgingWithOtherLob:
    '與此行程相關的其他所有預訂均適用合作夥伴的規定。',
  ResponseNoLodgingWithOtherLob: '與此行程相關的所有預訂均適用合作夥伴的規定。',
  ResponseAlreadyCancelled:
    '您有 {x} 筆住宿預訂已經遭到取消。由於許多旅客都需要變更或取消行程，退款流程可能會有所延誤。如果您任何疑問，請致電給我們的客服。',
  ResponseNoFlexAvailable:
    '您有 {x} 筆住宿預訂取消後不會獲得退款或抵用券。如果您選擇現在取消，我們會依照住宿方的標準取消規定處理，但取消規定可能會改變。您可以在行程開始 8 天前回來查看最新的取消規定。',
  ResponseInvalidDuplicateItinerary:
    '您的申請已經送出。目前行程出發時間較早的取消要求會優先處理。如果我們沒有在您的出發日期前確認取消，請不用擔心，我們都有在處理。您不需要做任何事情。',
  ResponseElligibleConfirmation: '您要取消預訂嗎？',
  ResponseInvalidUnknown:
    '我們找不到此行程或確認編號。請檢查後再試一次。您可以在原本預訂後收到的電子郵件中找到該組編號。',
  ResponseInvalidItineraryNotFound:
    '我們找不到此行程或確認編號。請檢查後再試一次。您可以在原本預訂後收到的電子郵件中找到該組編號。',
  ResponseInvalidTripMoreThanSevenDays: '我們無法處理您的申請。',
  ResponseInvalidTripIsLcc:
    '取消相關事宜是由航空公司處理，請直接聯絡航空公司。請登入您的帳戶查看線上行程以了解詳情。目前正在處理中的取消要求，最多可能需要 72 小時才會在行程中顯示為已經取消。',
  ResponseInvalidTripIsTicketless:
    '取消相關事宜是由航空公司處理，請直接聯絡航空公司。請登入您的帳戶查看線上行程以了解詳情。目前正在處理中的取消要求，最多可能需要 72 小時才會在行程中顯示為已經取消。',
  ResponseInvalidItinerary: '無法識別此行程編號。請再試一次。',
  ResponseInvalidStatus: '發生錯誤。請再試一次。',
  ResponseInvalidEmail:
    '我們無法辨識此電子郵件地址，或郵件地址不符合預訂此行程時使用的信箱。請確認您使用的是預訂時的信箱地址。',
  ResponseInvalidPhone:
    '我們無法識別此電話號碼。請確認您使用的是預訂時的電話號碼。',
  ResponseTripHasLccFlight:
    '我們可以取消您的部分預訂，但無法取消全部。無法取消的部分，請您直接聯絡業者。您可以查看線上行程，了解還有哪些預訂尚未取消。目前正在處理中的取消要求，最多可能需要 72 小時才會在行程中顯示為已經取消。',
  ResponseErrorTripWithin24Hrs:
    '由於您提出取消的時間離出發日期不到 24 小時，故無法處理。請登入您的帳戶查看線上行程以了解詳情。',
  ResponseInvalidTripInCruise:
    '我們無法透過此表格處理遊輪預訂的取消申請。請登入帳戶後從行程中線上取消。',
};

export default zhTw;
